import { Component, inject, OnInit } from '@angular/core';
import { SidebarEnum } from '../../models/common/sidebar.enum';
import { SidebarService } from '../../services/common/sidebar.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  standalone: true
})
export class FooterComponent implements OnInit {

    private readonly _sidebarService = inject(SidebarService);

    minWidth: number = 800;
    isMobileState: boolean = innerWidth<this.minWidth;
    sidebarState: SidebarEnum = this.isMobileState?SidebarEnum.mobileCollapsed:SidebarEnum.desktopLarge;
    environmentName: string = environment.environment;

    ngOnInit(): void {
        this._sidebarService.sidebarStateObservable.subscribe({
            next: (state) => {
                this.sidebarState = state;
            }
        });
        this._sidebarService.isMobileResolutionObservable.subscribe({
            next: (isMobileState) => {
                this.isMobileState = isMobileState;

            }
        })
    }

    public get footerStyles() {

        let left = '';
        if(this.isMobileState){
            left = '0px';
        } else {
            switch (this.sidebarState) {
                case SidebarEnum.desktopLarge: {
                    left = '270px';
                    break;
                }
                case SidebarEnum.desktopSmall: {
                    left = '80px';
                    break;
                }
                default: {
                    left = '270px';
                    break;
                }
            }
        }

        return {
            'left': left,
        };
    }

}
